var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var _a;
import { REACT_APP__URL_EASYPOST_BASE } from "@smp/utils";
import { apiRequest } from "../../lib";
export class ApiEpWatermark {
}
_a = ApiEpWatermark;
/**
 * Used to get watermarks billing config (available count, cost and so on)
 */
ApiEpWatermark.config = () => __awaiter(void 0, void 0, void 0, function* () {
    return apiRequest({
        endpoint: `${REACT_APP__URL_EASYPOST_BASE}api/v1/watermark-info`,
        method: "GET",
    });
});
/**
 * Used to create new Watermark
 */
ApiEpWatermark.create = ({ watermark, }) => __awaiter(void 0, void 0, void 0, function* () {
    return apiRequest({
        body: watermark,
        endpoint: `${REACT_APP__URL_EASYPOST_BASE}api/v1/watermark`,
        method: "POST",
    });
});
/**
 * Used to delete Watermark
 */
ApiEpWatermark.destroy = ({ id }) => __awaiter(void 0, void 0, void 0, function* () {
    return apiRequest({
        endpoint: `${REACT_APP__URL_EASYPOST_BASE}api/v1/watermark/${id}`,
        method: "DELETE",
    });
});
/**
 * Used to get Watermark by id
 */
ApiEpWatermark.get = ({ watermarkId, }) => __awaiter(void 0, void 0, void 0, function* () {
    return apiRequest({
        endpoint: `${REACT_APP__URL_EASYPOST_BASE}api/v1/watermark/${watermarkId}`,
        method: "GET",
    });
});
/**
 * Used to get Watermarks list
 */
ApiEpWatermark.list = () => __awaiter(void 0, void 0, void 0, function* () {
    return apiRequest({
        endpoint: `${REACT_APP__URL_EASYPOST_BASE}api/v1/watermark?archived=false`,
        method: "GET",
    });
});
/**
 * Used to update Watermark
 */
ApiEpWatermark.update = (_b) => __awaiter(void 0, void 0, void 0, function* () {
    var _c = _b.watermark, { id } = _c, rest = __rest(_c, ["id"]);
    return apiRequest({
        body: rest,
        endpoint: `${REACT_APP__URL_EASYPOST_BASE}api/v1/watermark/${id}`,
        method: "PUT",
    });
});
//# sourceMappingURL=watermark.js.map